import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SelectableRow from 'components/selectable_record_table/selectable_row';

import { getCurrentColumns } from './store/selectors/session';
import { getDefaultColumns } from './store/selectors/static';
import { valueOrPlaceholder } from 'helpers/string_helpers';
export class RequirementsSetRow extends React.Component {
  static propTypes = {
    currentColumns: PropTypes.array.isRequired,
    defaultColumns: PropTypes.array.isRequired,
    requirementsSet: PropTypes.object.isRequired
  };

  render() {
    return (
      <SelectableRow hideCheckbox>
        {this.renderPropertyCells()}
      </SelectableRow>
    );
  }

  renderPropertyCells() {
    const { currentColumns, defaultColumns, requirementsSet } = this.props;
    const requirementSetCells = [];

    [...defaultColumns, ...currentColumns].forEach((column) => {
      if (column == "parentName") {
        requirementSetCells.push(
          <td key={column}>
            <strong>
              <a href={requirementsSet.parentPath}>{requirementsSet.parentName}</a>
            </strong>
          </td>
        );
      } else if (["name", "notes"].includes(column)) {
        requirementSetCells.push(
          <td key={column}>
            <div className="text-truncate" style={{ maxWidth: '300px' }}>{valueOrPlaceholder(requirementsSet[column])}</div>
          </td>
        );
      } else {
        requirementSetCells.push(
          <td className="d-none d-md-table-cell" key={column}>
            {valueOrPlaceholder(requirementsSet[column])}
          </td>
        );
      }
    });

    return requirementSetCells;
  }
}

const mapStateToProps = state => ({
  currentColumns: getCurrentColumns(state),
  defaultColumns: getDefaultColumns(state)
});

export default connect(mapStateToProps, {})(RequirementsSetRow);
